<template>
  <Modal :id="id" :modalTitle="modalTitle">
    <label class="generalLabel" for="vendorCheck">Introduce el nombre completo para confirmar</label>
    <input type="text" class="form-control generalInput  mb-3" id="vendorCheck" :placeholder="[userNameCheck]"
      v-model.trim="confirmVendor">
    <button class="btn btn-primary generalPrimaryButton float-right" :disabled="confirmVendor != userNameCheck"
      data-dismiss="modal" aria-label="Close" @click="deleteUser()">Eliminar
      usuario</button>
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'UserDelete',
  props: [
    'id',
    'modalTitle',
    'class',
    'userNameCheck',
  ],
  data() {
    return {
      confirmVendor: ''
    }
  },
  watch: {
    userNameCheck() {
      this.confirmVendor = '';
    }
  },
  components: {
    Modal,
  },
  methods: {
    deleteUser() {
      let bodyToSend = {
        username: this.confirmVendor,
      }
      console.log(bodyToSend)
      axios.delete('/user/delete', { data: bodyToSend })
        .then((response) => {
          console.log(response)
          this.$emit("refreshRegisterList");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
